import Loader from '@stories/Components/Misc/Loader/Loader';
import React from 'react';
import { StepLoadingStyles as S } from './StepLoading.styles';
const StepLoading = () => {
    return (React.createElement(S.Container, null,
        React.createElement(Loader, null)));
};
export default StepLoading;
